module.exports = __webpack_public_path__ + "static/media/arrowlfts.a0f41a0e.svg";